export default {
	title: 'My profile',
	messages: {
		choose_plan: 'Choose a plan',
		unlock_immediately: 'Unlock immediately all functionalities',
		current_subscription: 'Your current subscription'
	},
	language: {
		title: 'Language',
		description: 'Choose the language of the interface',
		languages: {
			de: 'German',
			en: 'English',
			es: 'Spanish',
			fr: 'French',
			hi: 'Hindi',
			it: 'Italian',
			ja: 'Japanese',
			pt: 'Portuguese',
			zh: 'Chinese (Mandarin)'
		}
	},
	theme: {
		title: 'Theme selection'
	},
	actions: {
		manage_subscription: 'Manage my subscription'
	},
	api_access: {
	  title: "API access (MCP server)",
	  description: "Allow AI agents (Claude, ChatGPT, etc.) to access your Gerositus projects via the Model Context Protocol. The token grants the same access you have — keep it secret.",
	  endpoint: "MCP endpoint URL",
	  no_token: "No token yet — generate one to enable AI agent access.",
	  default_token_name: "Default token",
	  status_active: "Active",
	  status_revoked: "Revoked",
	  created_at: "Created on {{date}}",
	  last_used_at: "Last used on {{date}}",
	  never_used: "Never used yet",
	  generate: "Generate token",
	  regenerate: "Renew token",
	  revoke: "Revoke token",
	  copy: "Copy",
	  copied: "Copied to clipboard",
	  copy_failed: "Failed to copy",
	  config_example: "Example MCP client configuration",
	  reveal_title: "Save your token now",
	  reveal_done: "I have saved it",
	  reveal_warning_title: "This is the only time you will see this token",
	  reveal_warning_body: "Copy it somewhere safe (a password manager). If you lose it, you'll need to renew it. Anyone with this token can read your Gerositus projects.",
	  regenerate_confirm_title: "Renew your access token?",
	  regenerate_confirm_body: "The current token will be revoked immediately and a new one will be issued. Any AI agent using the old token will need to be reconfigured.",
	  revoke_confirm_title: "Revoke your access token?",
	  revoke_confirm_body: "Any AI agent using this token will lose access. You can generate a new one anytime."
	}
};
